import { LocalStorageAPI } from 'API/LocalStoreApi';
import { eLocalStorageTags } from 'API/eLocalStorageTags';

export const PinnedAndRecentAPI = LocalStorageAPI.injectEndpoints({
  endpoints: (build) => ({
    getMostRecent: build.query<string[], void>({
      query: () => ({
        url: `Search Bar Recent Orders`,
        method: 'GET',
      }),
      providesTags: [{ type: eLocalStorageTags.MostRecent, id: 'LIST' }],
    }),
    setMostRecent: build.mutation<void, string[]>({
      query: (body) => ({
        url: `Search Bar Recent Orders`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: [{ type: eLocalStorageTags.MostRecent, id: 'LIST' }],
    }),
    getPinned: build.query<string[], void>({
      query: () => ({
        url: `Search Bar Pinned Orders`,
        method: 'GET',
      }),
      providesTags: [{ type: eLocalStorageTags.Pinned, id: 'LIST' }],
    }),
    setPinned: build.mutation<void, string[]>({
      query: (body) => ({
        url: `Search Bar Pinned Orders`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: [{ type: eLocalStorageTags.Pinned, id: 'LIST' }],
    }),
  }),
});

export const { useGetMostRecentQuery, useGetPinnedQuery, useSetMostRecentMutation, useSetPinnedMutation } =
  PinnedAndRecentAPI;
